import React from 'react';
import { useNavigate } from 'react-router-dom';
import ManualSelectForm from '../components/ManualSelectForm';

const SearchManual = () => {
  const navigate = useNavigate();

  const handleSelect = (field) => {
    navigate('/search-map', { state: { category: field, reason: 'Manual selection' } });
  };

  const handleBack = () => {
    navigate(-1);
  };

  return <ManualSelectForm onSelect={handleSelect} onSkip={handleBack} />;
};

export default SearchManual;
